import axios from "axios";
const host = `${process.env.REACT_APP_API_URL}/api`;

export const setToken = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export const call = async (method, path, data) => {
  const response = await axios[method](`${host}/${path}`, data);
  console.log("response",response);
  return response.data;
};

export default { call, setToken };